// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:focus {
  outline: 0 !important;
}

p {
  color: var(--dark-2);
}

.p-field {
  margin-bottom: 1rem;
}

.p-field > label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

::ng-deep .contact-form-wrapper form input.ng-dirty.ng-invalid {
  color: red;
}
::ng-deep .contact-form-wrapper form ::ng-deep p-dropdown.ng-dirty.ng-invalid div.p-dropdown {
  border: 1px solid red !important;
}
::ng-deep .contact-form-wrapper .section-title h6 {
  font-weight: 600;
  display: inline-block;
  margin-bottom: 15px;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 30px;
  padding: 8px 30px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  ::ng-deep .contact-form-wrapper {
    padding: 20px !important;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  ::ng-deep .contact-form-wrapper {
    padding: 20px !important;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
/* Large devices (laptops/desktops, 992px and up) */
/* Extra large devices (large laptops and desktops, 1200px and up) */`, "",{"version":3,"sources":["webpack://./src/app/common/contact/contact.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,qBAAA;AACF;;AAKY;EACE,UAAA;AAFd;AAQwB;EACI,gCAAA;AAN5B;AAcY;EACI,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;AAZhB;;AAwBA,iDAAA;AACA;EAEI;IACE,wBAAA;EAtBJ;AACF;AA0BA,oEAAA;AACA;EAEI;IACE,wBAAA;EAzBJ;AACF;AA6BA,qDAAA;AAGA,mDAAA;AAGA,oEAAA","sourcesContent":[":focus {\n  outline: 0 !important;\n}\n\np {\n  color: var(--dark-2);\n}\n\n.p-field {\n  margin-bottom: 1rem;\n}\n\n.p-field > label {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\n::ng-deep {\n    .contact-form-wrapper {\n        form {\n            input.ng-dirty.ng-invalid {\n              color: red\n            }\n\n            ::ng-deep p-dropdown {\n                &.ng-dirty.ng-invalid {\n                    div {\n                        &.p-dropdown {\n                            border: 1px solid red !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        .section-title {\n            h6 {\n                font-weight: 600;\n                display: inline-block;\n                margin-bottom: 15px;\n                color: var(--primary);\n                border: 2px solid var(--primary);\n                border-radius: 30px;\n                padding: 8px 30px;\n            }\n        }\n    }\n}\n\n\n\n.contact-form-wrapper {\n\n}\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n  ::ng-deep {\n    .contact-form-wrapper {\n      padding: 20px !important;\n    }\n  }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) {\n  ::ng-deep {\n    .contact-form-wrapper {\n      padding: 20px !important;\n    }\n  }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) {}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) {}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
